import { QueryFunctionContext } from 'react-query';
import { API } from '../api';

export function fetchUsers({ signal, pageParam = 1, queryKey }: QueryFunctionContext) {
    const nameObj = queryKey[1] ? { name: queryKey[1] } : {};
    return API.get(API.PATH.getAllUsers, {
        params: {
            limit: 10,
            page: pageParam,
            ...nameObj,
        },
        signal: signal,
    }).then((response) => response.data);
}

export function fetchBlockedUsers({ signal }: QueryFunctionContext) {
    return API.get(API.PATH.getBlockedUsers, {
        params: {},
        signal: signal,
    }).then((response) => response.data);
}

export function fetchUserLogsSummary({ signal, queryKey }: QueryFunctionContext) {
    const [, userId, page = 1] = queryKey as [string, string, number];
    return API.get(API.PATH.getUserLogsSummary(userId), {
        params: {
            limit: 30,
            page,
        },
        signal,
    }).then((response) => response.data);
}

interface BlockUserPayload {
    userId: string;
    isPermanent: boolean;
    blockedTill?: string;
    gameId?: string;
}

export function blockUser({ userId, ...data }: BlockUserPayload) {
    return API.post(API.PATH.blockUser(userId), data).then((response) => response.data);
}

// export function fetchUserDetails({ signal, queryKey }: QueryFunctionContext) {
//     const [, userId] = queryKey as string[];
//     return API.get(API.PATH.getAllUsers, { signal }).then((res) => res.data);
// }
